<script>
	import { getExtensionEnvironment, watchObject } from "cando-util";

	import { store } from "$lib/utilities/store";

	export let email;

	$: checkAccounts = Object.keys($store.extensions?.docs || {})
		.map((eid) => $store.extensions.docs[eid])
		.filter(
			(e) =>
				e.type === "Department" &&
				getExtensionEnvironment(e) === "Production" &&
				// (e.queueMembers || []).includes(email) &&
				true,
		)
		.map((e) => ({
			extensionId: e.id.toString(),
			...$store.extensions.docs[e.id.toString()],
			viewerEmails: [
				...new Set(
					(e.queueMembers || [])
						.map(
							(m) =>
								$store.extensions.docs[m.id.toString()]
									.authorizedEmails || [],
						)
						.reduce((a, v) => [...a, ...v], []),
				),
			],
		}))
		.filter((a) => (a?.viewerEmails || []).includes(email));
	$: watchObject(checkAccounts, "checkAccounts");

	$: title = `${checkAccounts.length} Account${checkAccounts.length === 1 ? "" : "s"}`;
</script>

<div class="collapse collapse-arrow">
	<input type="checkbox" />
	<div class="collapse-title">{title}</div>
	<div class="collapse-content">
		{#each $store.extensions && checkAccounts.sort( (a, b) => (a.name < b.name ? -1 : 1), ) as account}
			<div class="flex justify-between mb-2">
				<div>
					{account.name}
				</div>
			</div>
		{/each}
	</div>
</div>
